export const isLowTextingCredits = (creditsLeft: number, totalCredits: number) => {
  const threshold = totalCredits * 0.1;
  return creditsLeft <= threshold && creditsLeft > 0;
};
